<template>
    <div class="pop-up">
        <el-form :model="form" :rules="rules" ref="formPassword" label-width="100px">
            <!-- 原密码输入框：用Element-UI自带的show-password实现显隐，极简写法 -->
            <el-form-item label="原密码：" prop="passWord">
                <el-input 
                    v-model="form.passWord" 
                    type="password"
                    show-password
                    autocomplete="new-password"
                    placeholder="请输入原密码"
                ></el-input>
            </el-form-item>
            
            <!-- 新密码输入框：同样用自带的show-password -->
            <el-form-item label="新密码：" prop="newPassword">
                <el-input 
                    v-model="form.newPassword" 
                    type="password"
                    show-password
                    autocomplete="new-password"
                    placeholder="新密码须至少8位，且包含数字、大写字母、小写字母、特殊字符中的3种及以上！"
                ></el-input>
            </el-form-item>
            
            <!-- 确认密码输入框：同样简化 -->
            <el-form-item label="确认密码：" prop="confirmPassword">
                <el-input 
                    v-model="form.confirmPassword" 
                    type="password"
                    show-password
                    autocomplete="new-password"
                    placeholder="请再次输入新密码"
                ></el-input>
            </el-form-item>
        </el-form>
        <div class="btn_box" style="text-align:center; margin-top:20px;">
            <el-button class="btn_add_canle" @click="close()">取 消</el-button>
            <el-button class="btn_add_sure" @click="submit()" type="primary" :disabled="isDisabled">提 交</el-button>
        </div>
    </div>
</template>

<script>
// 简化组件导入：直接导入element-ui的form/input相关组件，避免命名冲突
import { Form, FormItem, Input, Button, Message } from 'element-ui'
import Cookies from 'js-cookie'
import Axios from '@/api/diyaxios'
import { JSEncrypt } from 'jsencrypt'

export default {
    name: 'editPassword',
    props: [],
    data() {
        // 密码校验规则保持不变（和后端对齐：≥8位 + 3种及以上字符类型）
        const validNewPassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('新密码不能为空！'));
            }
            if (value.length < 8) {
                return callback(new Error('新密码长度不能少于8位！'));
            }
            if (value === this.form.passWord) {
                return callback(new Error('新密码不能与原密码一致！'));
            }
            // 四类字符判断
            const hasNumber = /\d/.test(value);
            const hasUppercase = /[A-Z]/.test(value);
            const hasLowercase = /[a-z]/.test(value);
            const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{}|;':",./<>?]/.test(value);
            const typeCount = [hasNumber, hasUppercase, hasLowercase, hasSpecialChar].filter(Boolean).length;
            
            if (typeCount < 3) {
                return callback(new Error('需数字、大写字母、小写字母、特殊字符中的3种及以上！'));
            }
            callback();
        }

        const validConfirmPassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('确认密码不能为空！'));
            } else if (value !== this.form.newPassword) {
                callback(new Error('两次密码输入不一致！'));
            } else {
                callback();
            }
        }

        return {
            form: {
                passWord: '',
                newPassword: '',
                confirmPassword: ''
            },
            isDisabled: false,
            rules: {
                passWord: [
                    { required: true, message: '原密码不能为空', trigger: 'blur' },
                    { min: 6, max: 30, message: '密码位数最少6位！', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '新密码不能为空！', trigger: 'blur' },
                    { validator: validNewPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '确认密码不能为空！', trigger: 'blur' },
                    { validator: validConfirmPassword, trigger: 'blur' }
                ]
            }
        }
    },
    // 简化组件注册：用Element-UI原始组件名，避免命名错误导致输入框不显示
    components: { 
        'el-form': Form,
        'el-form-item': FormItem,
        'el-input': Input,
        'el-button': Button
    },
    methods: {
        close() {
            this.$emit('close');
        },
        submit() {
            const vm = this;
            vm.$refs.formPassword.validate((valid) => {
                if (valid) {
                    vm.isDisabled = true;
                    Axios.post('/pwd/action/change', {
                        params: {
                            oldPwd: vm.form.passWord,
                            newPwd: vm.form.newPassword,
                            userId: Cookies.get('UserID'),
                        }
                    }, {
                        headers: {
                            "Content-Type": "application/json",
                            userId: Cookies.get('UserID'),
                            token: Cookies.get('token')
                        }
                    }).then(res => {
                        if (res.code === '200') {
                            vm.$emit('ok');
                            this.$message.success('密码修改成功！');
                        } else {
                            vm.isDisabled = false;
                            this.$message.error({
                                message: res.errorMsg,
                                duration: 5 * 1000
                            });
                        }
                    }).catch(err => {
                        vm.isDisabled = false;
                        this.$message.error(err.response.data.errorMsg || '修改失败');
                    });
                }
            });
        },
        encrypt(str) {
            const jse = new JSEncrypt();
            const public_key = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAOSkUOZBS0PLxbXn0MP+UOq7S+83X3ODHqqdVSyuwwqYyoruPHlYgyJGTPrVDuRP7BKgAYE3nUyPP2XaUw9Dbd8CAwEAAQ==';
            jse.setPublicKey(public_key);
            return jse.encrypt(str);
        }
    }
}
</script>

<style lang="scss" scoped>
.pop-up {
    padding: 20px;
}

.btn_box {
    .el-button {
        margin: 0 10px;
        padding: 8px 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/setPassWord.vue